export const UTC_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSSS[Z]";
export const DATE_FORMAT ="DD/MM/YYYY";

export const CALENDAR_TIMEZONE = "UTC"
